const InsectLifeCycle = (InsectLifeCycle: string) => {
  switch (InsectLifeCycle) {
    case "EGG":
      return "알";
    case "NYMPH":
      return "약충";
    case "PUPA":
      return "번데기";
    case "LARVA":
      return "유충";
    case "LARVA1":
      return "유충 1령";
    case "LARVA2":
      return "유충 2령";
    case "LARVA3":
      return "유충 3령";
    case "LARVA4":
      return "유충 4령";
    case "LARVA5":
      return "유충 5령";
    case "IMAGO":
      return "성충";
  }
};

export default InsectLifeCycle;
